import type { ServiceResponse } from "./axios";
import { privateApi, publicApi } from "./axios";

export type Session = {
  token: string;
  type: string;
  expiresIn: number;
};

export type LoginResponse = {
  accessToken: string;
  tokenType: string;
  expiresIn: number;
};

export type ForgotPasswordResponse = {
  message: string;
};

export type ResetPasswordResponse = {
  message: string;
};

export type LoginRequest = {
  email: string;
  password: string;
};

export type ValidateResetPasswordRequest = {
  token: string;
  email: string;
};

export type ConfirmResetPasswordRequest = {
  token: string;
  email: string;
  password: string;
  passwordConfirmation: string;
};

export const login = async (credentials: LoginRequest) => {
  const response = await publicApi.post<ServiceResponse<LoginResponse>>("/auth/login", credentials);

  return response.data;
};
export const requestResetPassword = async ({ email }: { email: string }) => {
  const response = await publicApi.post<ServiceResponse<ForgotPasswordResponse>>(
    "/forgot-password",
    {
      email,
    },
  );

  return response.data;
};

export const validateResetPassword = async ({ email, token }: ValidateResetPasswordRequest) => {
  const payload = { token, profile: { email } };
  const response = await publicApi.post<void>("/password/reset/validate", payload);

  return response.data;
};

export const confirmResetPassword = async (payload: ConfirmResetPasswordRequest) => {
  const response = await publicApi.post<ServiceResponse<ResetPasswordResponse>>(
    "/reset-password",
    payload,
  );

  return response.data;
};

export const logout = async () => {
  return await privateApi.post("/auth/logout");
};
